var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _c(
        "el-breadcrumb",
        { attrs: { "separator-class": "el-icon-arrow-right" } },
        [
          _c("el-breadcrumb-item", [
            _vm._v(_vm._s(_vm.groupName) + "的面试邀请")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-button",
        {
          staticClass: "button",
          attrs: { type: "primary" },
          on: {
            click: function($event) {
              _vm.dialogVisible = true
            }
          }
        },
        [_vm._v("新增面试邀请")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "el-row" },
        _vm._l(_vm.list, function(item, key) {
          return _c(
            "div",
            { staticClass: "el-col el-col-4" },
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: {
                      name: "interviewTjk",
                      params: {
                        id: item.interviewInviteId,
                        groupName: _vm.groupName,
                        groupId: _vm.groupId
                      }
                    }
                  }
                },
                [
                  _c("div", { staticClass: "el-card is-always-shadow" }, [
                    _c("div", { staticClass: "el-card__body" }, [
                      _c(
                        "div",
                        { staticClass: "tab-box" },
                        [
                          item.endStatus == "Ongoing"
                            ? [
                                _c("span", { staticClass: "badge active" }, [
                                  _vm._v("进行中")
                                ])
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          item.endStatus == "End"
                            ? [
                                _c("span", { staticClass: "badge" }, [
                                  _vm._v("已结束")
                                ])
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c("p", { staticClass: "title" }, [
                            _vm._v(_vm._s(item.title))
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("span", { staticClass: "padding-r-sm" }, [
                              _vm._v("申请人数：" + _vm._s(item.applyNum))
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v("通过人数：" + _vm._s(item.passedNum))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("截止日期：" + _vm._s(item.expireTime))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "detail" }, [
                            _vm._v("查看详情")
                          ])
                        ],
                        2
                      )
                    ])
                  ])
                ]
              )
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.list.length > _vm.pageSize
        ? _c("pagination", {
            attrs: { pages: _vm.pages, pageNum: _vm.pageNum },
            on: { getData: _vm.getList }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增面试邀请",
            visible: _vm.dialogVisible,
            width: "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "add",
              attrs: {
                model: _vm.add,
                rules: _vm.rules,
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "面试主题", prop: "title" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { placeholder: "请控制在10个字内", clearable: "" },
                    model: {
                      value: _vm.add.title,
                      callback: function($$v) {
                        _vm.$set(_vm.add, "title", $$v)
                      },
                      expression: "add.title"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "面试邀请简述", prop: "description" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      type: "textarea",
                      autosize: "",
                      placeholder: "请控制在200个字内",
                      clearable: ""
                    },
                    model: {
                      value: _vm.add.description,
                      callback: function($$v) {
                        _vm.$set(_vm.add, "description", $$v)
                      },
                      expression: "add.description"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "截止日期", prop: "expireTime" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetime",
                      placeholder: "选择日期时间",
                      "value-format": "yyyy-MM-dd HH:mm:ss"
                    },
                    on: { change: _vm.changeHandlerStart },
                    model: {
                      value: _vm.add.expireTime,
                      callback: function($$v) {
                        _vm.$set(_vm.add, "expireTime", $$v)
                      },
                      expression: "add.expireTime"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addNew } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35a96e22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35a96e22","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/college/interview.vue
// module id = 1188
// module chunks = 0